class VehicleManager {
  processLabel(label) {
    if (label && label.match("^e")) {
      return label.replace("e ", '<i class="icone icon-e-aixam"></i>');
    } else if (label && label.match("^E")) {
      return label.replace("E ", '<i class="icone icon-e-aixam"></i>');
    } else if (label && label.match(" e ")) {
      return label.replace(
        " e ",
        '<i class="icone icon-e-aixam -between"></i>',
      );
    }

    return label;
  }

  truncate(str, num) {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  }
}

export const vehicleManager = new VehicleManager();
